import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#CEEDFF"
      d="M11 11.5a8.5 8.5 0 1 1 8.5 8.5h-10a5.5 5.5 0 1 1 1.787-10.7"
    />
    <path
      fill="#80C4FF"
      fillRule="evenodd"
      d="M21.353 2.183a9.5 9.5 0 0 0-9.752 4.04l-.19.295a9.5 9.5 0 0 0-.775 1.565l-.007.015-.21-.035A6.497 6.497 0 0 0 3 14.5 6.5 6.5 0 0 0 9.501 21h10a9.5 9.5 0 0 0 1.853-18.817M16.63 4.57A7.501 7.501 0 1 1 19.5 19h-10a4.5 4.5 0 0 1 0-9l.298.009q.15.009.296.028l.019.003-.01.062q-.102.692-.103 1.398a1 1 0 1 0 2 0 7.5 7.5 0 0 1 4.63-6.93"
      clipRule="evenodd"
    />
    <path
      fill="#80C4FF"
      d="M16 24a1 1 0 0 0-1-1H9a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1M24 24a1 1 0 0 0-1-1h-3a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1M20 27a1 1 0 1 1 0 2h-7a1 1 0 1 1 0-2z"
    />
  </svg>
);
const SvgIconWeatherCloudFog = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherCloudFog);
export default Memo;
